/**
 * 組織レポート v3 モバイル版（WebView 埋め込み）。
 *
 * モバイルアプリの「GB組織」タブが /embed/report/org を WebView で開く。
 * 2026-08-22 に、旧実装（Gb74OrgReport）からこの v3 へ差し替えた。
 *
 * 算出・文言はPC版（/analysis/org-report-v3）とまったく同じモジュールを使う。
 * 違うのは見せ方だけ（スマホ幅・縦スクロール・部署はアコーディオン）。
 */
import { Box, Alert, CircularProgress, Typography, Button } from '@mui/material';
import { useOrgReportV3Data } from '../hooks/useOrgReportV3Data';
import { Gb74OrgReportMobile } from './Gb74OrgReportMobile';

export const OrgReportEmbedV3Page: React.FC = () => {
  const { data, loading, error, reload } = useOrgReportV3Data();

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" py={8} gap={2}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          組織レポートを作成しています…
        </Typography>
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Box p={2}>
        <Alert
          severity="info"
          action={
            <Button color="inherit" size="small" onClick={reload}>
              再読み込み
            </Button>
          }
        >
          {error ?? 'レポートを表示できませんでした。'}
        </Alert>
      </Box>
    );
  }

  return <Gb74OrgReportMobile data={data} />;
};

export default OrgReportEmbedV3Page;
